export default {
    ENGLISH_INDIAN: 'en-IN',
    ENGLISH_AUSTRALIAN: 'en-AU',
    ENGLISH_UNITED_STATES: 'en-US',
    ENGLISH_LATIN_AMERICAN: 'es-US',
};